const CATEGORY_DISPLAY_NAMES: Record<string, string> = {
  "brand-ownership": "Brand Ownership",
  "brand-comparisons": "Brand Comparisons",
  "brand-deep-dives": "Brand Deep Dives",
  "brand-history": "Brand History",
  "company-deep-dive": "Company Deep Dive",
  "company-history": "Company History",
  "consumer-education": "Consumer Education",
  "geography-and-ownership": "Geography & Ownership",
  "guide": "Guide",
  "guides": "Guides",
  "industry-analysis": "Industry Analysis",
  "industry-ownership": "Industry Ownership",
  "m-and-a-news": "M&A News",
  "news-and-updates": "News & Updates",
  "news-and-analysis": "News and Analysis",
  "same-company": "Same Company",
};

export function displayCategory(slug: string): string {
  return CATEGORY_DISPLAY_NAMES[slug] || slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
